module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('span', [_vm._v("数学长征")]), _vm._v(" "), (_vm.phone) ? _c('div', {
    staticClass: "headerBtn"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('img', {
    staticStyle: {
      "width": "32px",
      "height": "32px"
    },
    attrs: {
      "src": require("./assets/imgs/user.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "padding": "0 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.phone))])]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "系统设置",
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "tool"
  }, [_c('i', {
    staticClass: "iconfont icon-xitongshezhi"
  })])]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "帮助",
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "tool"
  }, [_c('i', {
    staticClass: "iconfont icon-bangzhu"
  })])]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "退出",
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "tool",
    on: {
      "click": _vm.logoutReq
    }
  }, [_c('i', {
    staticClass: "iconfont icon-loginout"
  })])])], 1) : _vm._e()]), _vm._v(" "), _c('main', [_c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "animated fadeInLeft",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [_c('router-view', {
    staticClass: "router"
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1c132a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 250
// module chunks = 15